import React, { Component } from "react";
import { Button } from "react-bootstrap";
import AgeingTree from "../ageingTree/AgeingTree";
import { get } from "lodash";
import { isValidArray } from "../../helper";
import { ISSUE_STATUS } from "../../constant";

const cssHelper = {
  "Under Process": "under-process",
  "Under Decision": "under-decision",
  "Under Verification": "under-verification",
  "Under Consideration": "under-consideration",
  rejected: "reject",
  resolved: "resolved",
  hold: "on-hold"
};

class IssueAgeing extends Component {
  state = { show: false };

  toogleTreeChart = () => {
    this.setState(prevState => ({ show: !prevState.show }));
  };

  render() {
    const {
      ageingData,
      ageingName,
      issueId,
      totalDays,
      issueStatus
    } = this.props;
    const arr = (ageingName || "").split(" ");
    let name = "";
    let barPercentage = 0;
    if (arr.length > 1) {
      for (let index = 0; index < 2; index++) {
        if (arr[index]) {
          name += arr[index][0];
        }
      }
    } else {
      name = ageingName.substr(0, 2);
    }

    return (
      <React.Fragment>
        <div className="issue-ageing issue-ageing-yellow">
          <div className="avatar">{(name && name.toUpperCase()) || "NA"}</div>
          <div className="ia-desc-wrapper">
            <div className="ia-desc-inner">
              <div className="ia-desc">
                <b>{ageingName || "NA"}</b>
              </div>
              <div className="ia-day-hierarchy">
                <b>
                  {isValidArray(ageingData) &&
                    get(ageingData[0], "totalDays", "NA")}{" "}
                  days
                </b>
                <ul className="ia-hierarchy-days">
                  {(isValidArray(ageingData) &&
                    ageingData.map((value, index) => {
                      value.totalDays && (barPercentage = value.totalDays);
                      return (
                        <li key={`ageing-${index}`}>
                          <Button
                            className={`btn-small ${cssHelper[
                              get(value, "workflowState")
                            ] || cssHelper["Under Process"]}`}
                          >
                            {get(value, "workflowState")}
                          </Button>
                          <b>{get(value, "days")} days</b>
                        </li>
                      );
                    })) ||
                    null}
                </ul>
                {(isValidArray(ageingData) &&
                  get(ageingData[0], "tree") &&
                  (issueStatus === ISSUE_STATUS["Pending with RM/RS"] ||
                    issueStatus === "Pending with RD") 
                  //   && (
                  //   <React.Fragment>
                  //     <span>(still counting)</span>
                  //     <div
                  //       className="know-hierarchy"
                  //       onClick={this.toogleTreeChart}
                  //     >
                  //       Know Why?
                  //     </div>
                  //   </React.Fragment>
                  // )
                  ) ||
                  null}
              </div>
            </div>
            <div className="progress">
              <div
                className="progress-bar"
                style={{ maxWidth: (barPercentage / totalDays) * 100 + "%" }}
              />
            </div>
          </div>
        </div>
        {(get(this.state, "show") && (
          <AgeingTree
            issueId={issueId}
            treeParent={ageingData[0]}
            show={get(this.state, "show", false)}
            toogleTreeChart={this.toogleTreeChart}
          />
        )) ||
          null}
      </React.Fragment>
    );
  }
}

export default IssueAgeing;
